(() => {
const THRESHOLD = 5000;
const GIFT_PROP = '_mr_pochette_offer';
const GIFT_VAL = '50';

  let isGiftOperation = false;
  let isRefreshingGift = false;
  let refreshTimer = null;

  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.Shopify.money_format || window.theme?.moneyFormat || '{{amount}} €');
    }

    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('Impossible de récupérer le panier');
    return await res.json();
  };

  const isGiftItem = (item) => {
    return item.properties && item.properties[GIFT_PROP] === GIFT_VAL;
  };

  const changeCartLineByKey = async (lineKey, quantity) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });

    if (!res.ok) {
      throw new Error('Erreur lors de la modification du panier');
    }

    return await res.json();
  };

  const addGiftVariant = async (variantId) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              [GIFT_PROP]: GIFT_VAL
            }
          }
        ]
      })
    });

    if (!res.ok) {
      throw new Error('Erreur lors de l’ajout du cadeau');
    }

    return await res.json();
  };

  const removeAllGiftItems = async (giftItems) => {
    for (const gift of giftItems) {
      await changeCartLineByKey(gift.key, 0);
    }
  };

  const refreshGiftUI = async () => {
    if (isGiftOperation || isRefreshingGift) return;

    const root = document.querySelector('[data-ah-gift150-root]');
    if (!root) return;

    isRefreshingGift = true;

    try {
      const cart = await fetchCart();

      let eligibleTotal = 0;
      const giftItems = [];

      cart.items.forEach((item) => {
        if (isGiftItem(item)) {
          giftItems.push(item);
        } else {
          eligibleTotal += item.final_line_price;
        }
      });

      const selectedGift = giftItems[0] || null;
      const selectedGiftVariantId = selectedGift ? Number(selectedGift.variant_id) : null;

      const isUnlocked = eligibleTotal >= THRESHOLD;
      const remaining = Math.max(0, THRESHOLD - eligibleTotal);
      const pct = Math.min(100, Math.max(0, (eligibleTotal / THRESHOLD) * 100));

      const bar = root.querySelector('[data-ah-gift150-bar]');
      const progressText = root.querySelector('[data-ah-gift150-progress]');
      const statusText = root.querySelector('[data-ah-gift150-status]');
      const toggleBtn = root.querySelector('[data-ah-gift150-toggle]');
      const btns = root.querySelectorAll('[data-ah-gift150-add]');

      if (bar) bar.style.width = `${pct}%`;

      if (isUnlocked) {
        root.classList.add('is-unlocked');
        root.classList.remove('is-locked');

        if (statusText) {
          statusText.textContent = selectedGift
? 'Votre pochette à -50% est bien ajoutée.'
: 'Seuil atteint ! Ajoutez votre pochette à -50%.';
        }

if (progressText) progressText.textContent = '50€ atteints';

        if (root.dataset.autoOpen !== 'true' && !selectedGift) {
          root.classList.add('is-expanded');
          root.classList.remove('is-collapsed');
          root.dataset.autoOpen = 'true';
        }
      } else {
        root.classList.remove('is-unlocked');
        root.classList.add('is-locked');
        root.dataset.autoOpen = 'false';

        if (root.dataset.manualToggle === 'true') {
          const wantExpanded = root.dataset.manualExpanded === 'true';

          root.classList.toggle('is-expanded', wantExpanded);
          root.classList.toggle('is-collapsed', !wantExpanded);
        } else {
          root.classList.remove('is-expanded');
          root.classList.add('is-collapsed');
        }

if (statusText) statusText.textContent = 'Ajoutez des articles pour débloquer votre pochette à -50%.';
if (progressText) progressText.textContent = `Plus que ${formatMoney(remaining)} pour débloquer l’offre`;

        if (giftItems.length > 0) {
          isGiftOperation = true;

          try {
            await removeAllGiftItems(giftItems);
            window.location.reload();
            return;
          } finally {
            isGiftOperation = false;
          }
        }
      }

      if (toggleBtn) {
        toggleBtn.setAttribute(
          'aria-expanded',
          root.classList.contains('is-expanded') ? 'true' : 'false'
        );
      }

      btns.forEach((btn) => {
        const variantId = Number(btn.dataset.variantId);

        btn.disabled = false;

        if (!isUnlocked) {
          btn.textContent = 'Ajouter';
          btn.disabled = true;
          btn.dataset.state = 'locked';
          return;
        }

        if (selectedGiftVariantId === variantId) {
          btn.textContent = 'Ajoutée';
          btn.disabled = true;
          btn.dataset.state = 'selected';
          return;
        }

        btn.textContent = 'Ajouter';
        btn.dataset.state = 'idle';
      });
    } catch (error) {
      console.error('Erreur cadeau offert :', error);
    } finally {
      isRefreshingGift = false;
    }
  };

  const debounceRefreshGiftUI = (delay = 400) => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshGiftUI, delay);
  };

  document.body.addEventListener('click', async (e) => {
    const toggle = e.target.closest('[data-ah-gift150-toggle]');

    if (toggle) {
      e.preventDefault();

      const root = toggle.closest('[data-ah-gift150-root]');
      if (!root) return;

      const isExpanded = root.classList.contains('is-expanded');

      root.dataset.manualToggle = 'true';
      root.dataset.manualExpanded = isExpanded ? 'false' : 'true';

      root.classList.toggle('is-expanded', !isExpanded);
      root.classList.toggle('is-collapsed', isExpanded);

      toggle.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
      return;
    }

    const addBtn = e.target.closest('[data-ah-gift150-add]');

    if (addBtn && !addBtn.disabled) {
      e.preventDefault();

      const variantId = Number(addBtn.dataset.variantId);
      if (!variantId) return;

      addBtn.textContent = 'Ajout...';
      addBtn.disabled = true;

      isGiftOperation = true;

      try {
        const cart = await fetchCart();
        const giftItems = cart.items.filter(isGiftItem);

        if (giftItems.length > 0) {
          await removeAllGiftItems(giftItems);
        }

        await addGiftVariant(variantId);

        window.location.reload();
      } catch (error) {
        console.error('Erreur ajout cadeau :', error);
        addBtn.textContent = 'Erreur';
        addBtn.disabled = false;
      } finally {
        isGiftOperation = false;
      }
    }
  });

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (isGiftOperation) return response;

    const request = args[0];
    const url = typeof request === 'string'
      ? request
      : request && request.url
        ? request.url
        : '';

    const isCartMutation =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear');

    if (isCartMutation) {
      debounceRefreshGiftUI(500);
    }

    return response;
  };

  const observer = new MutationObserver(() => {
    if (isGiftOperation || isRefreshingGift) return;

    const root = document.querySelector('[data-ah-gift150-root]');
    if (root) debounceRefreshGiftUI(400);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshGiftUI);
  } else {
    refreshGiftUI();
  }
})();